var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThanks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 121,
    viewBox: "0 0 144 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2695 0.120919C-19.9962 1.63431 0.54781 48.1375 18.603 71.1999C86.2767 174.153 133.007 88.2867 142.328 59.6144C151.649 30.9421 120.102 -1.77082 42.2695 0.120919Z",
    fill: "#368AD0",
    fillOpacity: 0.14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32821_11772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.889 56.1489H25.1111V77.8789H118.889V56.1489Z",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.889 77.8789H25.1111V99.8839H118.889V77.8789Z",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9978 66.813H32.3313",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9978 87.9717H32.3313",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.889 66.813H112.555",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.889 87.9717H112.555",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8781 48.5743C35.1181 35.9637 37.7781 21.2796 43.8794 20.1158C49.9806 18.9521 57.3908 31.4781 61.0009 43.5597",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4445 56.0854C31.0645 53.6733 30.769 51.0496 30.5579 48.1509C30.5579 48.1509 40.8603 48.3201 46.4971 55.8526",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4761 55.9376C46.4761 55.9376 55.8707 45.6333 64.4843 41.5073C65.9044 45.4323 66.9437 49.4853 67.5877 53.6101",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.594 56.0855C108.631 55.2411 109.592 54.3065 110.465 53.2925C118.382 44.0885 110.127 38.6719 110.127 38.6719C110.127 38.6719 104.723 30.3988 95.5181 38.3333C91.4225 41.8457 87.0735 49.1031 83.5479 56.0643",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2114 45.8237L94.1882 48.8071",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.875 39.1586L112.006 38.8835C111.766 38.8708 111.532 38.8088 111.317 38.7012C111.102 38.5937 110.911 38.4429 110.756 38.2584C110.602 38.0738 110.487 37.8594 110.419 37.6284C110.351 37.3974 110.33 37.1549 110.36 36.9158L111.352 28.7485",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8749 36.0906C97.9608 34.6757 96.711 33.51 95.2373 32.6976C93.7636 31.8853 92.112 31.4517 90.4303 31.4357C89.5228 31.4507 88.6212 31.5859 87.7491 31.8377C87.7584 31.7039 87.7584 31.5695 87.7491 31.4357C87.8117 30.0616 87.5956 28.689 87.1141 27.4009C86.6325 26.1127 85.8954 24.9358 84.9472 23.9412C83.9991 22.9466 82.8596 22.155 81.5977 21.6141C80.3357 21.0733 78.9775 20.7944 77.605 20.7944C76.2325 20.7944 74.8742 21.0733 73.6122 21.6141C72.3503 22.155 71.2108 22.9466 70.2627 23.9412C69.3146 24.9358 68.5774 26.1127 68.0959 27.4009C67.6143 28.689 67.3983 30.0616 67.4608 31.4357C67.4608 31.5626 67.4608 31.6896 67.4608 31.8377C65.8572 31.3714 64.1616 31.3209 62.5332 31.6909C60.9047 32.061 59.3967 32.8396 58.1506 33.9536",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6655 56.2336V39.3066",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6355 43.5386L76.6657 49.8862L83.7592 43.5386",
    stroke: "#368AD0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32821_11772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 84,
    fill: "white",
    transform: "translate(23 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanks);
export default __webpack_public_path__ + "static/media/thanks.2e3f93f50107b19474e644ae31797352.svg";
export { ForwardRef as ReactComponent };